import NewsIALayout from '../../../layouts/NewsIALayout.vue'
import NewsIA from '../views/NewsIA'
import Favorites from '../views/Favorites'
import History from '../views/History'
import Shorts from '../views/Shorts'
import TopCompanies from '../views/TopCompanies'
import HuggingFace from '../views/HuggingFace'
import Leaderboard from '../views/Leaderboard'

export default [
  {
      path: '/news',
      component: NewsIALayout,
      meta: { title: 'Noticias'},
      children: [
        {
          path: '',
          name: '',
          component: NewsIA,
          meta: { title: 'Noticias | Inicio', sourceType: 'notice' },
        },
        {
          path: 'papers',
          name: 'papers',
          component: NewsIA,
          meta: { title: 'Noticias | Papers', sourceType: 'pappers' },
        },
        {
          path: 'courses',
          name: 'courses',
          component: NewsIA,
          meta: { title: 'Noticias | Educación', sourceType: 'educational' },
        },
        {
          path: 'forums',
          name: 'forums',
          component: NewsIA,
          meta: { title: 'Noticias | Foros', sourceType: 'forum' },
        },
        {
          path: 'videos',
          name: 'videos',
          component: NewsIA,
          meta: { title: 'Noticias | Videos', sourceType: 'youtube' },
        },
        {
          path: 'shared/:shareId',
          name: 'news-shared',
          component: NewsIA,
          meta: {
            title: 'Noticias | Compartido',
            isShared: true,
            sourceType: 'notice'
          },
        },
        {
          path: 's/:shareId',
          name: 'news-short-share',
          component: NewsIA,
          meta: {
            title: 'Noticias | Compartido',
            isShared: true,
            sourceType: 'notice'
          },
        },
        {
          path: 'favorites',
          name: 'favorites',
          component: Favorites,
          meta: { title: 'Noticias | Favoritos' },
        },
        {
          path: 'history',
          name: 'history',
          component: History,
          meta: { title: 'Noticias | Historial' },
        },
        {
          path: 'huggingface',
          name: 'huggingface',
          component: HuggingFace,
          meta: { title: 'Noticias | HuggingFace' },
        },
        {
          path: 'leaderboard',
          name: 'leaderboard',
          component: Leaderboard,
          meta: { title: 'Noticias | Ranking LLM' },
        },
        {
          path: 'top-companies/:company',
          name: 'top-company',
          component: TopCompanies,
          meta: { title: 'Noticias | TOP Tech 🔥' },
        },
      ],
    },
    {
      path: '/news/shorts',
      name: 'shorts',
      component: Shorts,
      meta: { title: 'Noticias | Shorts' },
    }
]